import { localStorage, pipe } from '@blade/std-lib'
import { STORAGE_PREFIX } from '@root/shared'

import * as ExploreFilter from '../model/explore-filter'

export const reatomExploreFiltersPersistence = (name: string) => {
  const STORAGE_KEY = `${STORAGE_PREFIX}/v1/explore-filters/${name}`
  const filters = pipe(localStorage.get(STORAGE_KEY), (raw) =>
    raw ? ExploreFilter.fromJSON(raw) : ExploreFilter.EMPTY,
  )

  const save = (filters: ExploreFilter.ExploreFilter) => {
    localStorage.set(STORAGE_KEY, ExploreFilter.toJSON(filters))
  }

  const clear = () => {
    localStorage.delete(STORAGE_KEY)
  }

  return {
    filters,
    save,
    clear,
  }
}
